module.exports = __webpack_public_path__ + "static/media/shower.a684ff8e.svg";